"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Manufacturing() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const checkLang = () => {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    };
    checkLang();
    window.addEventListener("storage", checkLang);
    return () => window.removeEventListener("storage", checkLang);
  }, []);
  return <section data-section-id="6151" id="privacypolicyeditorial" className="relative overflow-hidden bg-white py-24 md:py-48">
      <div className="absolute top-0 left-0 h-px w-full bg-border/60" />
      
      <div className="mx-auto max-w-[1280px] px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-24">
          
          <div className="lg:col-span-5">
            <div ref={sectionRef} className="group relative overflow-hidden rounded-lg border border-border bg-secondary/30" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 600ms cubic-bezier(0.16, 1, 0.3, 1), transform 600ms cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <div className="absolute top-4 left-4 z-10 text-primary transition-transform duration-500 group-hover:rotate-45">+</div>
              <div className="absolute bottom-4 right-4 z-10 text-primary transition-transform duration-500 group-hover:rotate-45">+</div>
              
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/factory_production_floor_v2.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/factory_production_floor_v2.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/factory_production_floor_v2.png-wvc-sizes" alt={isZh ? "Elite Group Corporation Limited 高精密製造設施廠房" : "Elite Group high-precision manufacturing facility floor"} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
            </div>
            
            <div className="mt-6 flex items-center gap-4 font-mono text-[10px] uppercase tracking-widest text-muted-foreground" style={{
            opacity: sectionVisible ? 1 : 0,
            transition: "opacity 600ms ease-out 400ms"
          }}>
              <span className="h-px w-8 bg-primary" />
              <span>{isZh ? "設施編號: EG-CN-2024" : "Facility ID: EG-CN-2024"}</span>
              <span className="ml-auto">{isZh ? "精密等級: A1" : "Precision Grade: A1"}</span>
            </div>
          </div>

          <div className="flex flex-col justify-center lg:col-span-7">
            <div className="font-mono text-[0.75rem] font-medium uppercase tracking-[0.2em] text-primary" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 600ms ease-out 100ms, transform 600ms ease-out 100ms"
          }}>
              {isZh ? "卓越製造工藝" : "Manufacturing Excellence"}
            </div>

            <h2 className="mt-8 font-sans text-foreground" style={{
            fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 600ms ease-out 200ms, transform 600ms ease-out 200ms"
          }}>
              {isZh ? <>
                  精密玩樂的 <br />
                  <span className="text-primary">建築師</span>
                </> : <>
                  Architects of <br />
                  <span className="text-primary">Precision Play</span>
                </>}
            </h2>

            <div className="mt-12 grid grid-cols-1 gap-8 border-t border-border pt-12 md:grid-cols-2" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 600ms ease-out 300ms, transform 600ms ease-out 300ms"
          }}>
              <p className="text-base leading-relaxed text-foreground/80">
                {isZh ? "我們營運兩座專門製造塑膠與毛絨產品的生產基地。我們的一體化管理模式確保每件產品從最初的原型設計到最終組裝，均符合嚴格的國際品質標準。" : "We operate two specialized manufacturing facilities dedicated to plastic and plush production. Our integrated approach ensures that every product meets rigorous international quality standards from the initial prototype to final assembly."}
              </p>
              <p className="text-base leading-relaxed text-foreground/80">
                {isZh ? "透過全面掌控旗下生產線，我們為全球品牌確保產品質量的一致性、產能規模化以及嚴格遵循全球各項合規要求。" : "By maintaining full control over our production lines, we guarantee consistency, scalability, and strict adherence to global compliance requirements for brands worldwide."}
              </p>
            </div>

            <div className="mt-16" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 600ms ease-out 400ms, transform 600ms ease-out 400ms"
          }}>
              <Button asChild size="lg" className="rounded-lg bg-primary px-8 py-6 text-sm font-bold uppercase tracking-widest text-primary-foreground hover:bg-primary/90">
                <Link to="#">
                  {isZh ? "探索生產基地" : "Explore Facilities"}
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 h-px w-full bg-border/60" />
    </section>;
}